import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stock-adj-range',
  templateUrl: './stock-adj-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockAdjustmentRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
